// extracted by mini-css-extract-plugin
export default {"company":"company-page_company__dvoV3","blockImg":"company-page_blockImg__aAS8I","info":"company-page_info__PHkod"};